<template>
  <main
    class="flex h-full w-full flex-row divide-x divide-slate-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-slate-600 dark:bg-slate-700"
  >
    <aside class="flex h-full max-h-full shrink-0 flex-col gap-2 py-3 md:w-64">
      <SettingsNav />
    </aside>
    <div class="flex h-full max-h-full min-w-0 flex-1 flex-col">
      <RouterView />
    </div>
  </main>
</template>

<script>
import SettingsNav from './nav/TheSettingsNav.vue'

/** Settings: FM's frame, the menu on the left and the page on the right. */
export default {
  name: 'TheSettingsPage',
  components: { SettingsNav }
}
</script>
